import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { Provider } from "react-redux";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./sass/App.scss";

const store = configureStore({
  reducer: rootReducer,
});

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
